import React from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import '../styles/TopBar.css';
import ContentCopy from '@mui/icons-material/ContentCopy';

const TopBar = ({ title, identifier, children }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(identifier);
  };

  return (
    <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center', mb: '1rem' }}>
      <Stack direction="row" sx={{ alignItems: 'center' }} spacing={2}>
        <Typography variant="h1" component="div">
          {title}
        </Typography>
        {identifier && (
          <>
            <Typography variant="h6">| {identifier}</Typography>
            <IconButton aria-label="copy" onClick={handleCopy}>
              <ContentCopy fontSize="small" />
            </IconButton>
          </>
        )}
      </Stack>
      {children}
    </Stack>
  );
};

export default TopBar;
